import React from "react";

import { useDispatch } from "react-redux";

import { formatDate } from "../../helpers/order_format";
import { AppDispatch } from "../../store";
import { getTime } from "../../store/slices/timeSlice";

import { CustomCalendar } from "./Calendar/CustomCalendar";
import {
  NextButton,
  StepContainer,
  StepTitle
} from "./styles";

type BookingStepDateProps = {
  date: Date | null;
  onSelectDate: (date: Date) => void;
  onNext: () => void;
  disabledDays: Date[];
}

export const BookingStepDate: React.FC<BookingStepDateProps> = ({ date, onSelectDate, onNext, disabledDays }) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleDateChange = (selectedDate: Date) => {
    onSelectDate(selectedDate);
    dispatch(getTime(formatDate(selectedDate)));
  };

  const isNextDisabled = !date;

  return (
    <StepContainer>
      <StepTitle>Выберите свободную дату</StepTitle>
      <CustomCalendar
        selectedDate={date}
        onChange={handleDateChange}
        disabledDays={disabledDays}
      />
      <NextButton
        onClick={onNext}
        disabled={isNextDisabled}
      >Далее
      </NextButton>
    </StepContainer>
  );
};
